import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import M_GUIDE_BASIC_01 from './M_GUIDE_BASIC_01';
import { getManualPdfUrl } from '../M_GUIDE_BASIC/M_GUIDE_BASIC';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';

export default function M_GUIDE_BASIC_01F() {
  const { manualKey: manualKeyParam } = useParams();
  const manualKey = manualKeyParam ? decodeURIComponent(manualKeyParam) : '';
  const { state } = useLocation();
  const label = state?.label ?? '매뉴얼';
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fileUrl = getManualPdfUrl(manualKey);
  const [loading, setLoading] = useState(false);
  const [renderPreview, setRenderPreview] = useState(fileUrl);
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pageWidth, setPageWidth] = useState(() => window.innerWidth);
  const [pageViewHeight, setPageViewHeight] = useState(0);

  const backToList = useCallback(() => {
    navigate('/M_Guide');
  }, [navigate]);

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName(label));
  }, [dispatch, label]);

  useEffect(() => {
    if (fileUrl == null) {
      dispatch(
        showSnackbar({
          message: '준비 중이거나 잘못된 매뉴얼입니다',
          type: 'info',
        })
      );
      navigate('/M_Guide', { replace: true });
      return;
    }
    setRenderPreview(fileUrl);
    setPageNumber(1);
    setNumPages(undefined);
    setPageViewHeight(0);
  }, [fileUrl, manualKey, dispatch, navigate]);

  useEffect(() => {
    const handleResize = () => setPageWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (loading) setLoading(false);
  }, [pageNumber, loading]);

  const onDocumentLoadSuccess = useCallback(({ numPages: total }) => {
    setNumPages(total);
  }, []);

  const goToPrevPage = useCallback(() => {
    if (pageNumber > 1) {
      setLoading(true);
      setPageNumber((p) => p - 1);
    } else {
      backToList();
    }
  }, [pageNumber, backToList]);

  const goToNextPage = useCallback(() => {
    if (numPages != null && pageNumber < numPages) {
      setLoading(true);
      setPageNumber((p) => p + 1);
    }
  }, [pageNumber, numPages]);

  const handleAdvanceOrComplete = useCallback(() => {
    if (numPages == null) return;
    backToList();
  }, [numPages, backToList]);

  if (fileUrl == null) {
    return null;
  }

  return (
    <div
      className="wrap"
      style={{
        height: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <M_GUIDE_BASIC_01
        label={label}
        fullUrl={fileUrl}
        onClose={backToList}
        renderPreview={renderPreview}
        loading={loading}
        onDocumentLoadSuccess={onDocumentLoadSuccess}
        pageNumber={pageNumber}
        pageWidth={pageWidth}
        pageViewHeight={pageViewHeight}
        setPageViewHeight={setPageViewHeight}
        goToPrevPage={goToPrevPage}
        goToNextPage={goToNextPage}
        onAdvanceStep={handleAdvanceOrComplete}
        numPages={numPages}
      />
    </div>
  );
}
